import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate } from 'react-router-dom'
import { preFixImgUrl } from '@/utils'
import OutLink from '@/components/OutLink';
import { PlatformEnum } from '@/service/api/types';

const Vip = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className='flex flex-col'>
      <div className='h-[800px] bg-cover bg-center bg-no-repeat flex items-center justify-center' style={{ backgroundImage: `url(${preFixImgUrl('1b829a8f97688ce5b31b08e13a6d1ccd.png')})` }}>
        <div className='w-8xl mx-auto px-10'>
          <div className='bg-linear-45 from-[#E4E6E7] to-[#EFF0F0] rounded-[20px] p-[60px] flex items-center justify-between'>
            <div className='flex flex-col gap-6'>

              <div className='rounded-[12px] rounded-bl-[0] bg-[#060606] w-fit h-[35px] leading-[35px]'>
                <LangText lngKey='e10ddb3e' className='text-white text-[18px] px-3'>{t('e10ddb3e')}</LangText>
              </div>
              <LangText lngKey='e10ddb3e' className='text-[44px] text-black font-bold'>{t('e10ddb3e')}</LangText>
              <LangText lngKey='0ea28797' className='text-[18px] text-[#3A3A3A] w-[430px] leading-[1.5]'>{t('0ea28797')}</LangText>
              <div className='flex gap-4'>
                <OutLink platform={PlatformEnum.VIP}>
                  <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] w-fit text-[18px] bg-[#060606] text-[#FFDDA3] cursor-pointer'>
                    <LangText lngKey='2c1f3357'>{t('2c1f3357')}</LangText>
                  </div>
                </OutLink>
                {/* <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] outline outline-[#131313] w-fit text-[18px] hover:bg-[#060606] hover:text-[#FFDDA3] hover:outline-none cursor-pointer'>
                  <LangText lngKey='34b49f32'>{t('34b49f32')}</LangText>
                </div> */}
              </div>
            </div>
            <img src={preFixImgUrl('d250160e6890e6504b3aba7c58c951cf.png')} className='h-[415px] w-[555px]' />
          </div>
        </div>

      </div>
      {/* vip专属预约服务 */}
      <div className='w-full bg-cover bg-center bg-no-repeat h-[309px] flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('f4d498316df0b17216b3301de3141022.png')})` }}>
        <LangText lngKey='21fa7ee1' className='text-[44px] text-black mt-[139px]'>{t('21fa7ee1')}</LangText>
        <LangText lngKey='cca1050e' className='text-[18px] text-[#3A3A3A] mt-6'>{t('cca1050e')}</LangText>
      </div>
      {/* 高级酒店预订 */}
      <div className='w-full h-[996px] bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('e8d608fd63c17e7a3fc1f9091524952c.png')})` }}>
        <div className='w-8xl mx-auto h-full px-10 flex justify-end items-center'>
          <div className='w-[582px] flex flex-col py-[66px] pl-[57px] pr-[50px] bg-[rgba(255,255,255,0.8)] items-start'>
            <LangText lngKey='9a93d916' className='text-[30px] font-bold text-black'>{t('9a93d916')}</LangText>
            <LangText lngKey='808aa15b' className='text-[18px] text-[#393939] leading-[1.5] mt-[29px]'>{t('808aa15b')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[35px] mb-[38px]'>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='9b415851' className='text-[20px]'>{t('9b415851')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='095ef669' className='text-[20px]'>{t('095ef669')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='6a0f7c65' className='text-[20px]'>{t('6a0f7c65')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='5d9e43d3' className='text-[20px]'>{t('5d9e43d3')}</LangText>
              </div>
            </div>
            <OutLink platform={PlatformEnum.VIP}>
              <div className='h-[47px] cursor-pointer w-fit rounded-[28px] bg-[#060606] px-[35px] flex items-center justify-center'>
                <LangText lngKey='bcc799b1' className='text-[18px] text-[#FFDDA3]'>{t('bcc799b1')}</LangText>
              </div>
            </OutLink>
          </div>
        </div>
      </div>
      {/* 机场专人护送 */}
      <div className='w-full h-[996px] bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('a9d8920ccaa3a293195dee6e59575334.png')})` }}>
        <div className='w-8xl mx-auto h-full px-10 flex justify-start items-center'>
          <div className='w-[582px] flex flex-col py-[66px] pl-[57px] pr-[50px] bg-[rgba(255,255,255,0.8)] items-start'>
            <LangText lngKey='1a101be7' className='text-[30px] font-bold text-black'>{t('1a101be7')}</LangText>
            <LangText lngKey='be534bb2' className='text-[18px] text-[#393939] leading-[1.5] mt-[29px]'>{t('be534bb2')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[35px] mb-[38px]'>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='9fb915ef' className='text-[20px]'>{t('9fb915ef')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='8f99d067' className='text-[20px]'>{t('8f99d067')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='6ecb2f10' className='text-[20px]'>{t('6ecb2f10')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='9f738a5b' className='text-[20px]'>{t('9f738a5b')}</LangText>
              </div>
            </div>
            <OutLink platform={PlatformEnum.VIP}>
              <div className='h-[47px] cursor-pointer w-fit rounded-[28px] bg-[#060606] px-[35px] flex items-center justify-center'>
                <LangText lngKey='bcc799b1' className='text-[18px] text-[#FFDDA3]'>{t('bcc799b1')}</LangText>
              </div>
            </OutLink>
          </div>
        </div>
      </div>
      {/* 百货店专享体验 */}
      <div className='w-full h-[996px] bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('5dae2c4191d93335e265c7fe93889694.png')})` }}>
        <div className='w-8xl mx-auto h-full px-10 flex justify-end items-center'>
          <div className='w-[582px] flex flex-col py-[66px] pl-[57px] pr-[50px] bg-[rgba(255,255,255,0.8)] items-start'>
            <LangText lngKey='7a547875' className='text-[30px] font-bold text-black'>{t('7a547875')}</LangText>
            <LangText lngKey='edb9309e' className='text-[18px] text-[#393939] leading-[1.5] mt-[29px]'>{t('edb9309e')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[35px] mb-[38px]'>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='537256bb' className='text-[20px]'>{t('537256bb')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='c6613ca5' className='text-[20px]'>{t('c6613ca5')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='01db65f6' className='text-[20px]'>{t('01db65f6')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='8505aa45' className='text-[20px]'>{t('8505aa45')}</LangText>
              </div>
            </div>
            <OutLink platform={PlatformEnum.VIP}>

              <div className='h-[47px] cursor-pointer w-fit rounded-[28px] bg-[#060606] px-[35px] flex items-center justify-center'>
                <LangText lngKey='bcc799b1' className='text-[18px] text-[#FFDDA3]'>{t('bcc799b1')}</LangText>
              </div>
            </OutLink>
          </div>
        </div>
      </div>

      {/* 高端餐厅预约 */}
      <div className='w-full h-[996px] bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('60288781ef6b09048af48b785d0289e2.png')})` }}>
        <div className='w-8xl mx-auto h-full px-10 flex justify-start items-center'>
          <div className='w-[582px] flex flex-col py-[66px] pl-[57px] pr-[50px] bg-[rgba(255,255,255,0.8)] items-start'>
            <LangText lngKey='79eb0c6b' className='text-[30px] font-bold text-black'>{t('79eb0c6b')}</LangText>
            <LangText lngKey='6ff60052' className='text-[18px] text-[#393939] leading-[1.5] mt-[29px]'>{t('6ff60052')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[35px] mb-[38px]'>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='2568c0a3' className='text-[20px]'>{t('2568c0a3')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='b7e64056' className='text-[20px]'>{t('b7e64056')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='b6a71c3d' className='text-[20px]'>{t('b6a71c3d')}</LangText>
              </div>
              <div className='flex gap-[14px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='da25db0d' className='text-[20px]'>{t('da25db0d')}</LangText>
              </div>
            </div>
            <OutLink platform={PlatformEnum.VIP}>
              <div className='h-[47px] cursor-pointer w-fit rounded-[28px] bg-[#060606] px-[35px] flex items-center justify-center'>
                <LangText lngKey='bcc799b1' className='text-[18px] text-[#FFDDA3]'>{t('bcc799b1')}</LangText>
              </div>
            </OutLink>
          </div>
        </div>
      </div>
      {/* 7*24小时服务 */}
      <div className='w-full bg-cover bg-center bg-no-repeat py-[160px]' style={{ backgroundImage: `url(${preFixImgUrl('1fd2d0b750a0930425d2ba01c71afa6d.png')})` }}>
        <div className='w-8xl mx-auto h-full px-10 flex justify-between'>
          <div className='flex flex-col justify-center'>
            <div className='rounded-[26px] rounded-bl-[0] bg-[#060606] w-fit px-6 h-[56px] leading-[56px] relative'>
              <LangText lngKey='97389aa9' className='text-white text-[20px] bg-linear-to-r from-[#FFD0A2] to-[#F8EDDB] bg-clip-text'>{t('97389aa9')}</LangText>
            </div>
            <LangText lngKey='7b22b3a2' className='text-[#060606] text-[30px] mt-[38px] font-bold'>{t('7b22b3a2')}</LangText>
            <LangText lngKey='8025c111' className='text-[#060606] text-[20px] mt-[27px] leading-[1.5]'>{t('8025c111')}</LangText>
            <div className='flex flex-col w-[560px] mt-[37px] gap-[30px]'>
              <div className='rounded-[20px] bg-linear-to-r from-[#FADDB8] to-[#F8EDDB] w-full h-[124px] px-7 flex items-center'>
                <img className='h-[74px] w-[74px] shrink-0 mr-[34px]' src={preFixImgUrl('de84780b353e43831dab99c238ace439.png')} />
                <div className='flex flex-col gap-4'>
                  <LangText lngKey='b4cbe632' className='text-black text-[24px] font-bold'>{t('b4cbe632')}</LangText>
                  <LangText lngKey='98a4aa43' className='text-black text-[18px] leading-[1.2]'>{t('98a4aa43')}</LangText>
                </div>
              </div>
              <div className='rounded-[20px] bg-linear-to-r from-[#FADDB8] to-[#F8EDDB] w-full h-[124px] px-7 flex items-center'>
                <img className='h-[74px] w-[74px] shrink-0 mr-[34px]' src={preFixImgUrl('704e3ca0c23351ff3d983a84187c96f6.png')} />
                <div className='flex flex-col gap-4'>
                  <LangText lngKey='c1b33078' className='text-black text-[24px] font-bold'>{t('c1b33078')}</LangText>
                  <LangText lngKey='c617a56c' className='text-black text-[18px] leading-[1.2]'>{t('c617a56c')}</LangText>
                </div>
              </div>
              <div className='rounded-[20px] bg-linear-to-r from-[#FADDB8] to-[#F8EDDB] w-full h-[124px] px-7 flex items-center'>
                <img className='h-[74px] w-[74px] shrink-0 mr-[34px]' src={preFixImgUrl('b21b58f1d6b83c7a45523644ae3dffb5.png')} />
                <div className='flex flex-col gap-4'>
                  <LangText lngKey='c7a30515' className='text-black text-[24px] font-bold leading-[1.2]'>{t('c7a30515')}</LangText>
                  <LangText lngKey='7a0ffaff' className='text-black text-[18px] leading-[1.2]'>{t('7a0ffaff')}</LangText>
                </div>
              </div>
            </div>
          </div>
          <img src={preFixImgUrl('4be31daf1fc51329e2b7fbad00005252.png')} className='w-[600px] h-[800px]' />
        </div>
      </div>
      <div className='w-full h-[436px] bg-cover bg-center bg-no-repeat flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('55fd30a32d0ab4f9ed66d29b9240ccc0.png')})` }}>
        <LangText className='text-white text-[44px] mt-[113px] bg-linear-to-r from-[#FFD0A2] to-[#F8EDDB] bg-clip-text' lngKey='52349252'>{t('52349252')}</LangText>
        <LangText className='text-white text-[30px] mt-[30px] bg-linear-to-r from-[#FFD0A2] to-[#F8EDDB] bg-clip-text font-normal' lngKey='fb375179'>{t('fb375179')}</LangText>
        <div className='flex gap-[25px] mt-[60px]'>
          <OutLink platform={PlatformEnum.VIP}>
            <div className='h-[62px] min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] outline  w-fit text-[24px] bg-linear-to-r from-[#F3CC9E] to-[#FFEAC8]  cursor-pointer text-black'>
              <LangText lngKey='bcc799b1'>{t('bcc799b1')}</LangText>
            </div>
          </OutLink>
          <div className='h-[62px] text-[#FFD09F] min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] outline outline-[#FFD09F] w-fit text-[24px]  cursor-pointer '
            onClick={() => navigate('/service-center')}
          >
            <LangText lngKey='ad839901'>{t('ad839901')}</LangText>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vip